import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    rightList:JSON.parse(sessionStorage.getItem('rightList')||'[]'),
    username:localStorage.getItem('username') || '',
    route:localStorage.getItem('route') || 'commit',
    userpower:JSON.parse(localStorage.getItem('userpower') || '[]'),
    userpath:JSON.parse(localStorage.getItem('userpath') || '[]'),
    userbtn:JSON.parse(localStorage.getItem('userbtn') || '[]'),
    userimage:localStorage.getItem('userimage') || '',
    userrole:localStorage.getItem('userrole') || '',
    isCollapseVuex:false,
    navtablist:JSON.parse(localStorage.getItem('navtablist') || '[]'),
    viewKey:localStorage.getItem('viewkey')||0,
    marks: {
        0: '35',
        20: '40',
        40: '45', 
        60: '50',
        80: '55',
        100: '60',
    }
  },
  getters: {
    allmenulist(state, getters) {
      let menulist = [];
      state.userpower.forEach((item) => {
        if (item.page && item.has_child == 1) {
          item.page.forEach((row) => {
            menulist.push({
              path: row.route,
              // name: `${item.name}-${row.name}`,
              name: row.name,
              id: row.id,
              plant_type:item.plant_type
            });
          });
        } else {
          menulist.push({ path: item.route, name: item.name, id: item.id,plant_type:item.plant_type });
        }
      });
      return menulist
    }
  },
  mutations: {
      setRoute(state,data){
        state.route = data;
        localStorage.setItem('route',data)
      },
      setRightList(state,data){
        state.rightList = data
        localStorage.setItem('rightList',JSON.stringify(data))
      },
      setUserImage(state,data){
        state.userimage = data;
        localStorage.setItem('userimage',data)
      },
      setUserName(state,data){
        state.username = data;
        localStorage.setItem('username',data)
      },
      setUserId(state,data){
          state.userid = data;
          localStorage.setItem('userid',data)
      },
      setUserRole(state,data){
        state.userrole = data;
        localStorage.setItem('userrole',data)
      },
      setUserPower(state,data){
        state.userpower = data;
        localStorage.setItem('userpower',JSON.stringify(data))
      },
      setUserPath(state,data){
        state.userpath = data;
        localStorage.setItem('userpath',JSON.stringify(data))
      },
      setUserBtn(state,data){
        state.userbtn = data;
        localStorage.setItem('userbtn',JSON.stringify(data))
      },
      setCollapse(state, value) {
          state.isCollapseVuex = value; // 修改状态
      },
      setNavTab(state, data) {
        state.navtablist = data; // 修改状态
        localStorage.setItem('navtablist',JSON.stringify(data))
      },
      setViewKey(state, data) {
        state.viewKey = data; // 修改状态
        localStorage.setItem('viewkey',data)
      }
  },
  actions: {
      toggleCollapse({ commit, state }) {
          commit('setCollapse', !state.isCollapseVuex); // 切换状态
      }
  },
  modules: {

  }
})
